function ppProductFactRows(description) {
  const values = new Map();
  const labels = {
    size: /^(?:size|dimensions?|taille|מידות|גודל)\s*[:：]\s*(.+)$/iu,
    material: /^(?:materials?|matière|matériau|חומר)\s*[:：]\s*(.+)$/iu,
    finish: /^(?:finish|finition|גימור)\s*[:：]\s*(.+)$/iu,
    backing: /^(?:backing|clutch|attachment|attache|fermoir|סוגר|סגירה|גב)\s*[:：]\s*(.+)$/iu
  };
  const lines = Array.from(description.querySelectorAll('li, p')).flatMap((node) => {
    const copy = node.cloneNode(true);
    copy.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
    return copy.textContent.split('\n').map((line) => line.replace(/^[\s•·–-]+/u, '').trim()).filter(Boolean);
  });
  lines.forEach((line) => {
    if (line.length > 150) return;
    Object.entries(labels).forEach(([key, pattern]) => {
      const match = line.match(pattern);
      if (match && !values.has(key)) values.set(key, match[1].trim());
    });
    if (!values.has('material') && /^(?:premium |durable )?(?:hard enamel|soft enamel|zinc alloy)/i.test(line)) values.set('material', line);
    if (!values.has('finish') && /^(?:polished |dyed )?(?:gold|silver|black).*(?:metal |plated )?finish$/i.test(line)) values.set('finish', line);
    if (!values.has('backing') && /^(?:secure )?(?:rubber|butterfly|locking|military).*(?:clutch|backing)$/i.test(line)) values.set('backing', line);
  });
  description.querySelectorAll('strong').forEach((node) => {
    const phrase = node.textContent.trim();
    if (phrase.length > 90) return;
    if (!values.has('material') && /\b(?:hard enamel|soft enamel|zinc alloy)\b/i.test(phrase)) values.set('material', phrase);
    if (!values.has('finish') && /\b(?:gold|silver|black)[\s\S]*(?:metal base|finish|plated metal)\b/i.test(phrase)) values.set('finish', phrase);
    if (!values.has('backing') && /\b(?:rubber|butterfly|locking)[\s\S]*(?:clutch|backing)\b/i.test(phrase)) values.set('backing', phrase);
  });
  if (!values.has('size')) {
    const dimension = description.textContent.match(/\d+(?:[.,]\d+)?\s*(?:mm|cm|inches?|מ[״"]מ|ס[״"]מ)(?:\s*[x×]\s*\d+(?:[.,]\d+)?\s*(?:mm|cm|inches?|מ[״"]מ|ס[״"]מ))?(?:\s*\(\d+(?:[.,]\d+)?\s*(?:mm|cm)\))?/i);
    if (dimension) values.set('size', dimension[0]);
  }
  return ['size', 'material', 'finish', 'backing'].filter((key) => values.has(key)).map((key) => [key, values.get(key)]);
}

function ppRenderProductFacts(scope = document) {
  scope.querySelectorAll('[data-pp-product-facts]').forEach((facts) => {
    const description = document.getElementById(`PPProductStory-${facts.dataset.sectionId}`);
    if (!description) return;
    const list = facts.querySelector('dl');
    list.replaceChildren();
    ppProductFactRows(description).forEach(([key, value]) => {
      const row = document.createElement('div');
      const label = document.createElement('dt');
      const detail = document.createElement('dd');
      label.textContent = facts.dataset[`label${key[0].toUpperCase()}${key.slice(1)}`];
      detail.textContent = value;
      row.append(label, detail);
      list.append(row);
    });
    facts.hidden = list.childElementCount === 0;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ppRenderProductFacts(), { once: true });
} else {
  ppRenderProductFacts();
}
document.addEventListener('shopify:section:load', (event) => ppRenderProductFacts(event.target));
